import React, { useEffect, useState } from 'react'
import './Actors.css';
import DefaultImg from "../../utils/Image/DefaultImg.png"
const Actors = ({id}) => {
    const [actors,setActors]=useState({});

     useEffect(()=>{
        getActors();
     },[id])

    async function getActors(){
        const data=await fetch(`https://api.themoviedb.org/3/movie/${id}/credits?api_key=95827c3fee6b7922a023ac65e529dca2&language=en-US`);
        const json=await data.json();
       // console.log(json)
        setActors(json.cast);
    }


    let box = document.querySelector('.Aitems');

    const btnpressprev = () => {
        let width = box.clientWidth;
        box.scrollLeft = box.scrollLeft - width;
        console.log(width)
    }

    const btnpressnext = () => {
        let width = box.clientWidth;
        box.scrollLeft = box.scrollLeft + width;
        console.log(width)
    }
  return (
    actors &&
    <div className='Aitems'>
    {/* <button className="Apre-btn" onClick={btnpressprev}><p>&lt;</p></button>
    <button className="Anext-btn" onClick={btnpressnext}><p>&gt;</p></button> */}
        {
            Object.values(actors).map((idx)=>(
                <div className='Aitem'>
                    <img className='Aimg'   src={`https://image.tmdb.org/t/p/w500/${idx.profile_path}`} style={{backgroundImage:"url("+"DefaultImg"+")"}}></img>
                    <h3 className='name'>{idx.name}</h3>
                    <h5 className='char'>{idx.character}</h5>
                </div>
            ))
        }
    </div>
  )
}

export default Actors